export default __webpack_public_path__ + "static/media/connect.d3511225.png";